import { observer } from "mobx-react";
import ButtonBack from "newApp/components/ButtonBack";
import MainLayout from "newApp/components/layouts/MainLayout";
import Button from "newApp/kit/components/Button";
import ButtonsContainer from "newApp/kit/components/ButtonsContainer";
import FlexColumn from "newApp/kit/components/FlexColumn";
import H1 from "newApp/kit/components/H1";
import Select from "newApp/kit/components/Select";
import { URL_SITE_EMAILTEMPLATES } from "newApp/routing/urls";
import { EmailTemplatesStore } from "../store";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import TextEditor from "newApp/components/TextEditor";
import H3 from "newApp/kit/components/H3";
import Checkbox from "newApp/kit/components/CheckBox";
import TextField from "newApp/kit/components/TextField";
import LoaderSpinner from "newApp/kit/components/LoaderSpinner";
import { ISelectOption } from "newApp/kit/components/Select/index.types";

const store = new EmailTemplatesStore();

const EmailTemplatesCreatePage: React.FC = () => {
  useEffect(() => {
    store.init();
    return () => {
      store.reset();
    };
  }, []);

  const { push } = useHistory();

  //   const onClickCreate = async () => {
  //     const id = await store.onCreate();
  //     if (id) push(URL_SITE_FAQ + `/${id}`);
  //   };

  return (
    <div className="template-page">
      <MainLayout isLoading={store.isLoading.page}>
        <H1>Создание шаблона письма</H1>
        <FlexColumn>
          <ButtonBack url={URL_SITE_EMAILTEMPLATES}>
            Назад к списку шаблонов
          </ButtonBack>
          <Select
            placeholder="Выберите раздел"
            options={store.type as ISelectOption[]}
            {...store.form.adapters.templateType}
            onChange={store.getEmailTemplate}
          />
          <TextField {...store.form.adapters.templateTitle} />
          <TextEditor
            onChange={(value) => store.form.changeValueByKey(value, "content")}
            value={store.form.values.content || ""}
            errorMessage={store.form.errors.content}
          />
          <FlexColumn>
            <Checkbox {...store.form.adapters.buttonAvailable}>Кнопки</Checkbox>
            <Checkbox {...store.form.adapters.showImage}>Изображение</Checkbox>
          </FlexColumn>
          {store.isLoading.templates ? (
            <LoaderSpinner />
          ) : (
            <>
              <H3>Шаблоны</H3>
              <ul className="template-page__list">
                {store.templateParams?.map((templateItem, idx) => {
                  return (
                    <li key={idx}>
                      <span className="template-page__list--templ">{`{${templateItem.paramName}}`}</span>
                      <span className="template-page__list--desc">
                        {templateItem.paramDescription}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </>
          )}
          <ButtonsContainer>
            <Button
              onClick={() => {
                store.saveEmailTemplate();
              }}
              disabled={store.isLoading.templates}
            >
              Создать
            </Button>
            <Button
              onClick={() => push(URL_SITE_EMAILTEMPLATES)}
              variant="secondary"
            >
              Отменить
            </Button>
          </ButtonsContainer>
        </FlexColumn>
      </MainLayout>
    </div>
  );
};

export default observer(EmailTemplatesCreatePage);
